module.exports = "<div class=\"header-root\">\n\t<div style=\"flex: 1;\">\n\t\t<img v-bind:src=\"logoSrc\" class=\"header-logo\">\n\t</div>\n\t<div style=\"flex: 5; text-align: right;\">\n\t\t<div class=\"time-date-wrapper\">\n\t\t\t<div style=\"flex: 6\">\n\t\t\t\t<div v-text=\"date\" class=\"date\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"clock-wrapper\">\n\t\t\t\t<img src=\"" + require("./clock.png") + "\" class=\"clock-img\">\n\t\t\t\t<span  v-text=\"time\" class=\"clock\"></span>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/header/header-root.html
// module id = 211
// module chunks = 0